import { useIdentityDao } from "./dao/useIdentityDao";
import { useCallback } from "react";

export const useApiLogout = () => {
  const identityDao = useIdentityDao();
  return useCallback(async () => {
    try {
      await identityDao.logout();
    } finally {
      const target = `${window.location.origin}/`;
      // Force a full navigation to the root (absolute URL for WebView compatibility)
      window.location.replace(target);
      // Fallback: if navigation is ignored by some WebViews, force a reload
      setTimeout(() => {
        window.location.reload();
      }, 50);
    }
  }, [identityDao]);
};
